import { ApiService } from "pwapi";

import {
  CASE_REPORT_FAILURE,
  CASE_REPORT_REQUEST,
  CASE_REPORT_SUCCESS,
  CASE_DISCLAIMERS_REQUEST,
  CASE_DISCLAIMERS_SUCCESS,
  CASE_DISCLAIMERS_FAILURE,
} from "./constants";
import { AsyncSagaAction, createAsyncSaga } from "../utils/asyncActions";

type CaseReportIds = {
  case_id: number;
  report_id: number;
};

export const fetchCaseReport: AsyncSagaAction<CaseReportIds> = createAsyncSaga(
  CASE_REPORT_REQUEST,
  CASE_REPORT_SUCCESS,
  CASE_REPORT_FAILURE,
  ({ case_id, report_id }: CaseReportIds) =>
    `cases/${case_id}/report/${report_id}`,
  ({ case_id, report_id }: CaseReportIds) =>
    ApiService.retrieveCaseReport({
      id: report_id,
      parentLookupCaseId: case_id,
    })
);

export const fetchCaseDisclaimers: AsyncSagaAction<{ case_id: number }> =
  createAsyncSaga(
    CASE_DISCLAIMERS_REQUEST,
    CASE_DISCLAIMERS_SUCCESS,
    CASE_DISCLAIMERS_FAILURE,
    ({ case_id }) => `cases/${case_id}/disclaimers/`,
    ({ case_id }) =>
      ApiService.listCaseDisclaimersPreviews({ parentLookupCaseId: case_id })
  );
